<template>
    <div id="editar-foto">
        <el-row :gutter="20" type="flex" justify="center" align="middle">
            <el-col :span="18" class="titulo">
                Editar Foto de Perfil
            </el-col>
        </el-row>
        <el-row :gutter="20" type="flex" justify="center" align="middle">
            <el-col :span="22" class="cuerpo">

                <v-alert v-if="estado" type="success" color="green" style="margin-bottom:30px" :value="true">
                    Los Cambios se Guardaron Correctamente.
                </v-alert>
                <v-alert v-if="error" type="error" color="red" style="margin-bottom:30px" :value="true">
                    Ha ocurrido un error intentando procesar su solicitud.<br>Por favor, intente nuevamente.
                </v-alert>
                <v-alert v-if="tiempo" type="error" color="orange" style="margin-bottom:30px" :value="true">
                    Su foto ya ha sido cambiada en un plazo menor a 24 hs. Intente mañana nuevamente.
                </v-alert>


                <!-- FOTO -->
                <el-form ref="ff">
                    <el-row :gutter="20" justify="center" style="margin-top:30px">
                        <el-col :xs="24" :sm="12" align="center">
                            <strong>Adjunte su Foto de Perfil</strong><br><br>
                            <div tabindex="0" class="el-upload el-upload--picture">
                                <el-button size="small" type="primary" @click="ClickInputFile('FlFoto')">
                                    Clic para subir archivo
                                </el-button>
                                <input id="FlFoto" type="file" @change="UpdateFoto($event)" style="display:none"/>
                            </div>
                            <div class="el-upload__tip">Ingrese un archivo del tipo jpg, jpeg, bmp o png.</div>
                            <br><br>
                            <div v-if="GuardarFoto">
                                <img :src="PreviewFoto" style="width:100%"/>
                            </div>
                        </el-col>
                        <el-col :xs="24" :sm="12" align="center" v-if="foto">
                            <strong>Imagen Actual</strong><br><br>
                            <img :src="foto" style="width:100%"/>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" justify="space-between" style="width:100%; margin-top:30px">
                        <el-col :xs="24" :sm="12" :md="8" style="float:right; margin-bottom:10px; margin-top:-5px">
                            <v-btn 
                                raised 
                                block
                                color="blue" 
                                :loading="cargando" 
                                :disabled="!GuardarFoto"
                                @click="FotoSubmit()"
                                style="color:#fff"
                            >
                                Guardar Cambios
                            </v-btn>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8" style="float:left">
                            <router-link class="el-col el-col-24 el-button el-button--danger"
                            :to="{ name: 'datos' }">
                                Volver
                            </router-link>
                        </el-col>
                    </el-row>
                </el-form>
            </el-col>
        </el-row>
    </div>
</template>


<script>
    import axios                    from 'axios';

    export default
    {   data()
        {   return {
                //Publicos
                Tipo:               this.$route.params.id,
                cargando:           false,
                estado:             false,
                error:              false,
                tiempo:             false,

                //Foto
                foto:               [],
                NuevaFoto:          [],
                NuevaFotoString:    '',
                PreviewFoto:        '#',
                GuardarFoto:        false,
            }
        },


        methods:
        {   ClickInputFile(id)
            {   document.getElementById(id).click();
            },
            UpdateFoto(event)
            {   this.NuevaFoto                                           = event.target.files;
                if(this.NuevaFoto[0].type=='image/jpeg' || this.NuevaFoto[0].type=='image/bmp' || this.NuevaFoto[0].type=='image/png')
                {   this.GuardarFoto                                     = true;
                    this.PreviewFoto                                     = URL.createObjectURL(event.target.files[0]);
                }
                else
                {   this.GuardarFoto                                     = false;
                    this.PreviewFoto                                     = '#';
                }
                var reader                                              = new FileReader();
                reader.onload                                           = this._handleReaderLoadedFoto.bind(this);
                reader.readAsBinaryString(this.NuevaFoto[0]);
            },
            _handleReaderLoadedFoto(readerEvt)
            {   var binaryString                                        = readerEvt.target.result;
                this.NuevaFotoString                                    = btoa(binaryString);  // Converting binary string data.
            },
            FotoSubmit()
            {   if(this.NuevaFotoString)
                {   this.cargando   = true;
                    this.estado     = false;
                    this.error      = false;
                    this.tiempo     = false;
                    var params      = 'tkn=' + this.$cookies.get('PDTK') + '&Name=' + this.NuevaFoto[0].name + '&Type=' + this.NuevaFoto[0].type + '&Foto=' + this.NuevaFotoString;
                    var headers     = new Headers();
                    headers.append('Content-Type', 'application/x-www-form-urlencoded');
                    axios.post('https://docentes.educaciondigitaltuc.gob.ar/aphpi/doc_foto_up.php', params, {headers: headers})
                        .then(response => {
                            const datos                                     = response.data;
                            if(datos=='Tiempo')
                            {   this.tiempo                                 = true;
                                window.scrollTo(0,0);
                            }
                            else
                            {   this.estado                                 = true;
                                this.error                                  = false;
                                this.GuardarFoto                            = false;
                                this.NuevaFoto                              = [];
                                this.NuevaFotoString                        = '';
                                this.PreviewFoto                            = '#';

                                var params  = 'tkn=' + this.$cookies.get('PDTK');
                                var headers = new Headers();
                                headers.append('Content-Type', 'application/x-www-form-urlencoded');
                                
                                axios.post('https://docentes.educaciondigitaltuc.gob.ar/aphpi/doc.php', params, {headers: headers})
                                    .then(response => {
                                        const datos                         = response.data
                                        this.foto                           = datos['foto'];
                                        window.scrollTo(0,0);
                                    })
                            }
                            this.cargando                                   = false;
                        })   
                        .catch(e => {
                            this.error                                      = true;
                            window.scrollTo(0,0);
                        })
                }
            }
        },


        beforeMount()
        {   if(!this.$cookies.get('PDTK'))
            {   this.$router.push('../login');
            }
            else
            {   var params  = 'tkn=' + this.$cookies.get('PDTK');
                var headers = new Headers();
                headers.append('Content-Type', 'application/x-www-form-urlencoded');
                
                axios.post('https://docentes.educaciondigitaltuc.gob.ar/aphpi/doc.php', params, {headers: headers})
                    .then(response => {
                        const datos                                         = response.data
                        this.foto                                           = datos['foto'];
                    })
                   /* .catch(e => {})*/
            }
        }
    };
</script>
